<!-- single checkbox mode -->
<div class="input-checkbox" (click)="toggleCheck(value)" *ngIf="!multiple || !options.length">
  <div
    class="input-checkbox-circle"
    [class.checked]="isChecked"
  >
    <i
      *ngIf="isChecked"
      class="fa-regular fa-check"
    ></i>
  </div>
  <span>{{ label }}</span>
</div>

<!-- multiple options mode -->
<div class="checkbox-group" *ngIf="multiple && options.length">
  <div class="checkbox-item" *ngFor="let option of options">
    <div class="input-checkbox" (click)="toggleCheck(option.value)">
      <div
        class="input-checkbox-circle"
        [class.checked]="isOptionChecked(option.value)"
      >
        <i
          *ngIf="isOptionChecked(option.value)"
          class="fa-regular fa-check"
        ></i>
      </div>
      <span>{{ option.text }}</span>
    </div>
  </div>
</div>
